import {suppliersList} from './../../../supplier/suppliers';
import {adminStates} from './../../admin-routes';

export default function AdminHotelSearchService(
    $q,
    $state,
    googleMapsService
) {
    'ngInject';

    return {
        getSuppliers,
        getLocations,
        getPlaceDetails,
        navigateToResultPage,
    };

    function getSuppliers() {
        return suppliersList;
    }

    function getLocations(input) {
        const deferred = $q.defer();
        const autocomplete = googleMapsService.getPlacesAutocompleteService();
        const placesStatuses = googleMapsService.getPlacesServiceStatuses();
        autocomplete.getPlacePredictions({input}, (resp, status) => {
            if (status === placesStatuses.OK) {
                deferred.resolve(resp);
            } else {
                deferred.reject();
            }
        });
        return deferred.promise;
    }

    function getPlaceDetails(placeId) {
        const deferred = $q.defer();
        const placesService = googleMapsService.getPlacesService();
        placesService.getDetails({placeId}, (place) => {
            deferred.resolve(place);
        });
        return deferred.promise;
    }


    function navigateToResultPage(params, allSuppliers) {
        const newParams = angular.copy(params);
        const areAllSuppliersSelected = !allSuppliers.filter(({id}) => !params.suppliers.includes(id)).length;

        if (areAllSuppliersSelected) {
            newParams.suppliers = [];
        }

        $state.go(
            adminStates.HOTEL_LIST_RESULTS,
            newParams,
            {reload: adminStates.HOTEL_LIST_RESULTS}
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-list/admin-hotel-search/admin-hotel-search-service.js